import React from 'react'
import styles from "./AboutTeam.module.css";

export const AboutTeam = () => {
    return (
        <div className={styles.container}>
            <h2 className={styles.title}>Our Vision</h2>
            <p className={styles.text}>
                Our dedicated team is focused on building AI hardware
                that not only accelerates computations but also offers
                energy efficiency, meeting the needs of a sustainable
                future. From autonomous vehicles to data centers, our
                chips power the most demanding AI applications.
            </p>
        </div>
    )
}
